export enum DataTypeStr {
    Int = 'Int',
    Double = 'Double',
    String = 'String'
}